import { connect } from 'react-redux';
import PanelConsent from './panelConsent'
import * as AC from '../../actions/actionCreators'

function mapStateToProps(state) { 
	return {
		visitorTerritory: state.profile.visitorTerritory,
		visitorName: state.profile.username,
		visitorId: state.profile.id,
		role: state.user.role,
		cycleName: state.panelConsent.cycleName,
		isLoading: state.panelConsent.isLoading,
		isSaving: state.panelConsent.isSaving,
		hasConsented: state.panelConsent.hasConsented
	};
}

function mapDispatchToProps(dispatch) {
	return({
		fetchPanelConsent: () => { dispatch(AC.PanelConsentLoadingStarted()) },
		savePanelConsent: (visitorName, visitorId, cycle) => { dispatch(AC.PanelConsentSaveStarted(visitorName, visitorId, cycle)) },
		checkConsentStatus: (cycle, visitorId) => { dispatch(AC.PanelConsentCheckStarted(cycle, visitorId)) }
	})
}

export default connect(mapStateToProps, mapDispatchToProps)(PanelConsent);
